export const ReportProgrammingModel = {
    id: "",
    name: "",
    description: "",
    panel: null,
    date_start: "",
    run: "",
    repeat: "w", // (d: DAY, w: WEEK, m: MONTH)
    values: {},
    report_type: "cp", // (cp: CONTAINER_PERCENTAGE, ch: CONTAINER_HISTORY, pr: PERFORMANCE_REPORT)
    email_recipients: [],
    filters: {},
};
// Valores que se emplearan
// week {days:[]}
// month {day: 1-31, value: 0, type: "d"} - by day
//     | {day: 0-6, value: 1-4, type: "n"} - by number
//     | {day: 0-6, value: "first | last", type: "p"} - by place
//
// year {day: 1-31, value: 1-12, type: "d"}
//     | {day: 0-6, value: 1-12, type: "n"}
//     | {day: 0-6, value: "first | last", type: "p"}
//
// days = Mon, Tue, Wed, Thu, Fri, Sat, Sun
//

export const ProgrammingDays = [
    "0", // D - U
    "1", // L - M
    "2", // M - T
    "3", // X - W
    "4", // J - R
    "5", // V - F
    "6", // S - S
];

export const OptionsTypes = {
    DAY: "d",
    NUMBER: "n",
    PLACE: "p",
};

export const RepeatTypes = {
    DAY: "d",
    WEEK: "w",
    MONTH: "m",
    YEAR: "y",
};

export const OptionsValues = {
    id: "",
    title: "",
    type: "",
    day: -1,
    value: "",
};
